import history from 'utils/history';

import { capitalize } from 'lodash';

import moment from 'moment-timezone';

/**
 *
 * GroupDetail
 *
 */
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import {
	ButtonDropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
} from 'reactstrap';

import { createStructuredSelector } from 'reselect';

import CustomButton from 'atoms/CustomButton';
import Table from 'atoms/Table';
import AttachmentCell from 'atoms/TableCell/AttachmentCell';
import ImageDetailsCell from 'atoms/TableCell/ImageDetailsCell';
import classnames from 'classnames';
import AddClientToGroup from 'components/AddClientToGroup';
import AddSessionModal from 'components/AddSessionModal';
import GroupAttendance from 'components/GroupAttendance';
import StatusModal from 'components/RequestSentModal';
import UpdateEnrollmentModal from 'components/UpdateEnrollmentModal';
import UpdateGroup from 'components/UpdateGroup';
import SendSurveyModal from 'components/SendSurveyModal';
import { BULLET } from 'constants/main';
import { downloadFile, generateToast, loadClinicians } from 'containers/App/actions';
import { loadGroupTypes, updateProgram } from 'containers/Therapies/actions';
import { makeSelectGroupTypes, makeSelectIsUpdating, makeSelectUpdateConflict } from 'containers/Therapies/selectors';
import { headerStyle } from 'containers/App/constants';
import { makeSelectAuth, makeSelectClinicians, makeSelectIsMobile } from 'containers/App/selectors';
import { compareWords } from 'utils/columnCompare';
import { CURRENT, FORMER, rowsForEnrollmentList } from 'utils/enrollments';
import { toastOptions } from 'utils/toast';

import {
	addClient,
	addSession,
	deleteSessions,
	fetchAllClients,
	getAttendance,
	getAttendanceSuccess,
	getClients,
	getSessions,
	loadProgram,
	saveAttendance,
	updateEnrollment,
	sendSurvey,
} from './actions';
import './index.css';
import makeSelectGroupDetail, {
	makeSelectAllClients,
	makeSelectGetAttendance,
	makeSelectGetClients,
	makeSelectGetProgram,
	makeSelectGetSessions,
	makeSelectReloadAttendance,
	makeSelectUpdateRequestError,
	makeSelectUpdateRequestSuccess,
} from './selectors';

/* eslint-disable react/prefer-stateless-function */

const patientLabels = [
	{
		name: 'My Attendance',
		id: 1,
	},
];
const adminLabels = [
	{
		name: 'Attendance',
		id: 1,
	},
	{
		name: 'Clients Enrolled',
		id: 4,
	},
	{
		name: 'Former Clients',
		id: 5,
	},
];
export class GroupDetail extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '1',
			dropdownOpen: false,
			showEditGroup: false,
			programId: '',
			program: null,
			showAddSession: false,
			showDeleteSessions: false,
			showUpdateEnroll: false,
			showAddClient: false,
			showSendSurvey: false,
			updateRequestSent: false,
			tabDropdownOpen: false,
			isSaving: false,
			sentUpdate: false,
		};
	}

	closeRequestSentModal = () => {
		this.setState({ updateRequestSent: false });
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { program } = nextProps;

		if (program) {
			this.setState({
				program,
			});
		}

		if (this.state.sentUpdate && !nextProps.isUpdating) {
			if (nextProps.updateConflict) {
				this.setState({ sentUpdate: false });
			} else {
				this.props.dispatch(loadProgram({ id: this.state.programId }));
				this.setState({ sentUpdate: false, showEditGroup: false });
			}
		}
	}

	downloadClientFile = (docs) => {
		const { downloadClientFile } = this.props;
		docs.forEach((id) => {
			if (id) {
				downloadClientFile(id);
			}
		});
	};

	toggleAddClientModal = () => {
		const { fetchAllClients, type } = this.props;
		const { showAddClient } = this.state;

		if (!showAddClient) {
			fetchAllClients(type);
		}

		this.setState((prevState) => ({
			showAddClient: !prevState.showAddClient,
		}));
	};

	toggleShowAddSession = () => {
		this.setState({
			showAddSession: !this.state.showAddSession,
		});
	};

	toggleShowDeleteSessions = () => {
		this.setState({
			showDeleteSessions: !this.state.showDeleteSessions,
		});
	};

	addNewSession = ({ startDate, endDate }) => {
		const { addNewSession } = this.props;
		const { program } = this.state;

		this.toggleShowAddSession();

		const data = {
			startDate: moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss'),
			endDate: moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss'),
			programId: program.programId,
		};

		addNewSession(data);
	};

	deleteSessions = (ids) => {
		const { deleteSessions } = this.props;
		const { program } = this.state;

		this.toggleShowAddSession();
		const data = {
			programId: program.programId,
			ids,
		};

		deleteSessions(data);
	};

	goToProfile = (id) => {
		const { auth } = this.props;

		history.push({
			pathname: `/${auth.loggedInUser.roleName}/dashboard/profile/${id}`,
		});
	};

	// One row per client per tab, so the date columns show the instance that put the
	// client in this tab: the open one in Clients Enrolled, the last ended one in
	// Former Clients. The modal still gets the client's full history.
	clientEnrolledColumns = () => {
		return [
			{
				field: 'client',
				title: 'CLIENT',
				headerStyle,
				render: (row) => (
					<div className="d-flex justify-content-start mx-2 p-0 mt-2 hand">
						<ImageDetailsCell
							src={row.client.profilePicture || ''}
							heading={row.client.name}
							primarySubHeading={capitalize(row.client.type)}
						/>
					</div>
				),
			},
			{
				field: 'docs',
				title: 'SIGNED DOCUMENTS',
				headerStyle,
				render: (row) => (
					<div
						className="d-flex justify-content-start mx-2 p-0 mt-2"
						onClick={() => this.downloadClientFile(row.docs)}
					>
						<AttachmentCell title={`${row.docs.length} documents`} />
					</div>
				),
			},
			{
				field: 'enrollment',
				title: 'START DATE',
				headerStyle,
				render: (row) => (
					<div className="d-flex justify-content-start font-14 mx-2 p-0 mt-2">
						{row.enrollment.startDate
							? moment(row.enrollment.startDate).format('MM-DD-YYYY')
							: '-'}
					</div>
				),
			},
			{
				field: 'enrollment',
				title: 'END DATE',
				headerStyle,
				render: (row) => (
					<div className="d-flex justify-content-start font-14 mx-2 p-0 mt-2">
						{row.enrollment.endDate
							? moment(row.enrollment.endDate).format('MM-DD-YYYY')
							: '-'}
					</div>
				),
			},
			{
				field: 'sendSurvey',
				headerStyle,
				render: (row) => (
					<div className="d-flex justify-content-end align-items-center mt-2">
						<button
							type="button"
							className="btn btn-primary primary-btn-color px-3 py-2 font-10"
							onClick={() => this.sendSurvey(row.client)}
						>
							Send Survey
						</button>
					</div>
				)
			},
			{
				field: 'updateEnroll',
				headerStyle,
				render: (row) => (
					<div className="d-flex justify-content-end align-items-center mt-2">
						<button
							type="button"
							className="btn btn-primary primary-btn-color px-3 py-2 font-10"
							onClick={() => this.updateEnrollment(row)}
						>
							Update Enrollment
						</button>
					</div>
				),
			},
		];
	};

	componentDidMount() {
		const {
			fetchClients,
			routeProps: {
				location: { pathname },
			},
			type,
			dispatch,
		} = this.props;
		const index = pathname.lastIndexOf('/');
		const programId = pathname.substring(index + 1, pathname.length);
		const data1 = {
			id: parseInt(programId, 10),
		};
		this.setState({ programId: parseInt(programId, 10) });
		if (programId) {
			dispatch(loadProgram(data1));
			if (type !== 'patient') {
				fetchClients({ programId });
				dispatch(loadClinicians());
				dispatch(loadGroupTypes());
			}
		}

		// ?openEdit=true asks for the edit form. render() holds it back until the program
		// has loaded and the viewer may edit it.
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('openEdit') === 'true') {
			this.setState({ showEditGroup: true });
			// Clean up URL
			window.history.replaceState({}, '', window.location.pathname);
		}
	}

	handleShowEditGroup = () => {
		this.setState((prevState) => ({
			showEditGroup: !prevState.showEditGroup,
		}));
	};

	// Who may open the edit form: admins, and a clinician on a current tenure of this
	// group (end dates are inclusive). program/update checks the assignment again
	// server-side. With the extend path retired this is how a clinician sets or clears
	// their group's end date (MTC-173); patients stay read-only.
	canEditGroup = () => {
		const { type, auth, program } = this.props;
		if (type === 'admin') return true;
		if (type !== 'clinician') return false;
		const today = moment().format('YYYY-MM-DD');
		return (program?.clinicians || []).some(
			(c) =>
				c.clinicianId === auth.loggedInUser.id &&
				(!c.endDate || c.endDate >= today),
		);
	};

	handleUpdateProgram = (data) => {
		this.props.dispatch(updateProgram(data));
		this.setState({ sentUpdate: true });
	};

	doUpdateEnrollment = (enrollments) => {
		const { updateEnrollment } = this.props;
		const { updateEnrollmentInfo, programId } = this.state;

		updateEnrollment({
			patientId: updateEnrollmentInfo.client.patientId,
			programId,
			enrollments,
		});

		this.setState({ showUpdateEnroll: false, updateRequestSent: true });
	};

	// Opens the modal on the client's whole history, whichever tab's row was clicked.
	// The modal props are built once here so a re-render of this page cannot reset the
	// periods the user is part-way through editing.
	updateEnrollment = (row) => {
		this.setState((prevState) => ({
			updateEnrollmentInfo: {
				client: row.client,
				groups: [
					{ programId: prevState.programId, enrollments: row.enrollments },
				],
			},
			showUpdateEnroll: true,
		}));
	};

	toggleUnenroll = () => {
		this.setState({ showUpdateEnroll: !this.state.showUpdateEnroll });
	};

	sendSurvey = (data) => {
		this.setState({ sendSurveyInfo: data, showSendSurvey: true });
	};

	toggleSurvey = () => {
		this.setState({ showSendSurvey: !this.state.showSendSurvey });
	};

	doSendSurvey = () => {
		const { sendSurvey, createToast } = this.props;
		const { sendSurveyInfo, programId } = this.state;

		sendSurvey(
			{
				patientId: sendSurveyInfo.patientId,
				phoneNumber: sendSurveyInfo.phone,
				programId: programId,
			},
			() =>
				createToast({
					text: 'SMS Sent Successfully',
					position: 'bottom-left',
					options: toastOptions,
				}),
			(message) =>
				createToast({
					type: 'error',
					text: message,
					position: 'bottom-left',
					options: {
						...toastOptions,
						bodyClassName: 'attendance-toast-body-error',
					},
				}),
		);

		this.setState({ showSendSurvey: false });
	}

	toggle = (tab) => {
		const { type, fetchClients } = this.props;
		const { programId } = this.state;
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab,
			});
			if (programId) {
				if (type !== 'patient') {
					fetchClients({ programId });
				}
			}
		}
	};

	toggleDropdown = () => {
		const { dropdownOpen } = this.state;
		this.setState({
			dropdownOpen: !dropdownOpen,
		});
	};

	addClient = (data) => {
		const { dispatch } = this.props;
		data.enrolledGroups.push({ value: this.props.program.programId });
		this.props.addClient(data, () => {
			dispatch(
				generateToast({
					text: 'Client Added Successfully',
					type: 'custom-success',
				}),
			);
			// Refetch so the new row carries its real enrollment instance ids.
			this.props.fetchClients({ programId: this.state.programId });
		});
	};

	getNavLink = (type) => {
		let headingLabel;
		if (type === 'patient') {
			headingLabel = patientLabels.map((value) => (
				<NavItem key={value.id}>
					<NavLink
						className={classnames(
							{
								active: this.state.activeTab === value.id.toString(),
							},
							'font-13',
						)}
						onClick={() => {
							this.toggle(value.id.toString());
						}}
					>
						{value.name}
					</NavLink>
				</NavItem>
			));
		}
		if (type === 'admin' || type === 'clinician') {
			headingLabel = adminLabels.map(
				(value) =>
					!(value.id === 6 && type === 'clinician') && (
						<NavItem key={value.id}>
							<NavLink
								className={classnames(
									{
										active: this.state.activeTab === value.id.toString(),
									},
									'font-13 hand',
								)}
								onClick={() => {
									this.toggle(value.id.toString());
								}}
							>
								{value.name}
							</NavLink>
						</NavItem>
					),
			);
		}
		return headingLabel;
	};

	updateAttendance = (data) => {
		const { doUpdateAttendance, createToast } = this.props;

		doUpdateAttendance(
			data,
			() =>
				createToast({
					text: 'Attendance Marked Successfully',
					position: 'bottom-left',
					options: toastOptions,
				}),
			() =>
				createToast({
					type: 'error',
					text: 'Attendance Could Not Be Taken',
					position: 'bottom-left',
					options: {
						...toastOptions,
						bodyClassName: 'attendance-toast-body-error',
					},
				}),
		);
	};

	saveAttendance = (data, newAttendance) => {
		const { doSaveAttendance, createToast, dispatch } = this.props;
		this.setState({ isSaving: true });

		doSaveAttendance(
			data,
			() => {
				createToast({
					text: 'Attendance Marked Successfully',
					position: 'bottom-left',
					options: toastOptions,
				});
				dispatch(getAttendanceSuccess(newAttendance));
				this.setState({ isSaving: false });
			},
			() => {
				createToast({
					type: 'error',
					text: 'Attendance Could Not Be Taken',
					position: 'bottom-left',
					options: {
						...toastOptions,
						bodyClassName: 'attendance-toast-body-error',
					},
				});
				this.setState({ isSaving: false });
			},
		);
	};

	toggleTabDropdown = () => {
		this.setState({ tabDropdownOpen: !this.state.tabDropdownOpen });
	};

	getDropdownLabel = (activeTab, type) => {
		let label;
		if (type === 'admin') {
			label = adminLabels.find((label) => label.id.toString() === activeTab);
		} else {
			label = patientLabels.find((label) => label.id.toString() === activeTab);
		}

		return label ? label.name : 'No Options';
	};

	getNav = () => {
		const { type, isMobile } = this.props;
		const { activeTab, tabDropdownOpen } = this.state;

		if (type === 'patient') {
			return <div></div>;
		}

		return (
			<div
				className={`${
					isMobile ? 'mb-1' : 'mb-2'
				} d-flex justify-content-between filter-nav`}
			>
				{isMobile ? (
					<ButtonDropdown
						direction="down"
						isOpen={tabDropdownOpen}
						toggle={this.toggleTabDropdown}
						className="w-100"
					>
						<DropdownToggle
							className="btn btn-white bg-white link-color btn-lg btn-block font-15 font-weight-bold d-flex custom-caret"
							nav
							caret
						>
							{this.getDropdownLabel(activeTab, type)}
						</DropdownToggle>
						{tabDropdownOpen && (
							<DropdownMenu className="w-100">
								{this.getNavLink(type).map((nav) => (
									<DropdownItem key={nav}>{nav}</DropdownItem>
								))}
							</DropdownMenu>
						)}
					</ButtonDropdown>
				) : (
					<div>
						<Nav
							tabs
							className="actions m-0 link-color w-100 border-bottom-0 shadow-none"
						>
							{this.getNavLink(type)}
						</Nav>
						<div className="col-1 p-0 d-flex justify-content-end bg-white">
							<div
								className="col-6 fa-filter border-bottom-0 shadow-none"
								onClick={this.handleChange}
							/>
						</div>
					</div>
				)}
			</div>
		);
	};

	getTabContent = (activeTab, type) => {
		let tabcontent;
		const {
			fetchAttendance,
			doDeleteSessions,
			attendance,
			fetchSessions,
			routeProps: {
				location: { data },
			},
			sessions,
			reloadAttendance,
			clients = [],
			auth,
			clinicians = [],
			createToast,
		} = this.props;

		const { program, isSaving } = this.state;

		if (type === 'patient') {
			tabcontent = (
				<TabContent activeTab={activeTab}>
					<TabPane tabId="1">
						<GroupAttendance
							auth={auth}
							fetchAttendance={fetchAttendance}
							attendance={attendance}
							programDetails={program || data}
							fetchSessions={fetchSessions}
							sessions={sessions}
							type={type}
							programId={this.state.programId}
							isSaving={isSaving}
						/>
					</TabPane>
				</TabContent>
			);
		}
		if (type === 'admin' || type === 'clinician') {
			tabcontent = (
				<TabContent activeTab={activeTab}>
					<TabPane tabId="1">
						<GroupAttendance
							auth={auth}
							fetchAttendance={fetchAttendance}
							attendance={attendance}
							saveAttendance={this.saveAttendance}
							programDetails={program || data}
							fetchSessions={fetchSessions}
							sessions={sessions}
							type={type}
							programId={this.state.programId}
							toggleShowAddSession={this.toggleShowAddSession}
							deleteSessions={doDeleteSessions}
							reload={reloadAttendance}
							isSaving={isSaving}
							clinicians={clinicians}
							createToast={createToast}
						/>
					</TabPane>
					<TabPane tabId="4">
						<div className="row">
							<div className="col-sm-12">
								<Table
									keyField="patientId"
									data={rowsForEnrollmentList(clients, CURRENT).sort((a, b) =>
										compareWords(a.client.name, b.client.name, 'asc'),
									)}
									columns={this.clientEnrolledColumns()}
									placeholder="No clients enrolled"
								/>
							</div>
						</div>
					</TabPane>
					<TabPane tabId="5">
						<div className="row">
							<div className="col-sm-12">
								<Table
									keyField="patientId"
									data={rowsForEnrollmentList(clients, FORMER).sort((a, b) =>
										compareWords(a.client.name, b.client.name, 'asc'),
									)}
									columns={this.clientEnrolledColumns()}
									placeholder="No former clients"
								/>
							</div>
						</div>
					</TabPane>
				</TabContent>
			);
		}
		return tabcontent;
	};

	isValidLink = () => {
		const { program } = this.props;
		const meetingLink = program.meetingLink;
		if (!meetingLink) return false;
		return meetingLink.indexOf('http://') === 0 || meetingLink.indexOf('https://') === 0;
	};

	getGroupTime = () => {
		const { program } = this.props;
		const { startTime, endTime } = program;
		const startTimeLocalFormatted = moment.utc(startTime).local().format('h:mm a');
		const endTimeLocalFormatted = moment.utc(endTime).local().format('h:mm a');
		const startTimePTFormatted = moment
			.utc(startTime)
			.tz('America/Los_Angeles')
			.format('h:mm a');
		const endTimePTFormatted = moment
			.utc(endTime)
			.tz('America/Los_Angeles')
			.format('h:mm a');
		const localTimeZone = moment().tz(moment.tz.guess()).format('z');
		const pacificTimeZone = moment().tz('America/Los_Angeles').format('z');
		let timeString = `${startTimeLocalFormatted} - ${endTimeLocalFormatted} ${localTimeZone}`;
		if(startTimeLocalFormatted !== startTimePTFormatted) {
			timeString += ` (${startTimePTFormatted} - ${endTimePTFormatted} ${pacificTimeZone} )`;
		}
		return timeString;
	};

	getProgramHeader = () => {
		const { program, type, isMobile, clients } = this.props;
		const canEdit = this.canEditGroup();
		// program/find serialises the DATE column at UTC midnight; read it as the UTC
		// calendar day, or the clinic sees the evening before. No end date: ongoing.
		const endDateLabel = program.endDate
			? moment.utc(program.endDate).format('MMM D, YYYY')
			: 'Ongoing';

		return (
			<div className={`container-fluid bg-white ${!isMobile && 'px-5'}`}>
				{isMobile ? (
					<div className="container">
						<div className="mx-auto">
							<div className="row pt-3 bg-white p-0">
								<div className="m-auto font-25 text-center">
									{program.groupName}
								</div>
							</div>
							<div className="row py-0 bg-white py-2 justify-content-center">
								<div className="m-0 font-14 font-weight-bold">
									{moment.utc(program.startTime).local().format('h:mm a')} -{' '}
									{moment.utc(program.endTime).local().format('h:mm a')}
								</div>
								<div className="m-0 font-14 font-weight-bold">
									{program.inPerson && `In-Person ${BULLET}`}
									{program.location}
								</div>
							</div>
							{(type === 'patient' || type === 'admin') && program.clinicians?.length > 0 && (
								<div className="row justify-content-center ">
									{program.clinicians
										.filter((c) => (!c.startDate || moment(c.startDate).isSameOrBefore(moment(), 'day')) && (!c.endDate || moment(c.endDate).isSameOrAfter(moment(), 'day')))
										.map((clinician) => (
											<div className="p-2" key={clinician.clinicianId}>
												<ImageDetailsCell
													heading={clinician.clinicianName}
													primarySubHeading={clinician.therapistType}
												/>
											</div>
										))}
								</div>
							)}
						</div>
						{program.meetingLink && (
							<div className="row p-2 justify-content-center">
								<h6 className="text-dark m-0 font-13">
									<a href={program.meetingLink} target="_blank" rel="noopener noreferrer">
										Meeting Link
									</a>
								</h6>
							</div>
						)}
						<div className="row p-2 justify-content-around text-center">
							<div className="my-2 col-auto d-flex flex-column">
								<h6 className="detailed-nav">Last Session</h6>
								<div className="detailed-nav-value">
									{program.lastSession
										? moment(program.lastSession).format('MMM D, YYYY')
										: '-'}
								</div>
							</div>
							<div className="my-2 col-auto d-flex flex-column">
								<h6 className="detailed-nav">Upcoming Session</h6>
								<div className="detailed-nav-value">
									{program.upcomingSession
										? moment(program.upcomingSession).format('MMM D, YYYY')
										: '-'}
								</div>
							</div>
							<div className="my-2 col-auto d-flex flex-column">
								<h6 className="detailed-nav">End Date</h6>
								<div className="detailed-nav-value">{endDateLabel}</div>
							</div>
						</div>
					</div>
				) : (
					<div>
						{type === 'patient' || type === 'admin' ? (
							<div className="d-flex justify-content-center py-3 bg-white">
								<div
									className="d-flex align-items-center"
									onClick={canEdit ? this.handleShowEditGroup : undefined}
									style={canEdit ? { cursor: 'pointer' } : {}}
								>
									<div className="d-flex flex-column justify-content-center align-items-end border-right pr-4">
										<div className="m-0 font-25">{program.groupName}</div>
										<div className="m-0 font-14 font-weight-bold">
											{this.getGroupTime()}
										</div>
										<div className="m-0 font-14 font-weight-bold">
											{program.inPerson ? 'In Person ' : 'Remote '}
											{`${BULLET} `}
											{program.location}
										</div>
									</div>
									<div className="d-flex align-items-center pl-4" style={{ gap: '1.5rem' }}>
										{program.clinicians
											?.filter((c) => (!c.startDate || moment(c.startDate).isSameOrBefore(moment(), 'day')) && (!c.endDate || moment(c.endDate).isSameOrAfter(moment(), 'day')))
											.map((clinician) => (
												<ImageDetailsCell
													key={clinician.clinicianId}
													heading={clinician.clinicianName}
													primarySubHeading={clinician.therapistType}
												/>
											))}
									</div>
								</div>
							</div>
						) : (
							<div className="col-12 d-flex justify-content-center p-0 pt-3">
								<div
									className="d-flex flex-column justify-content-center align-items-center"
									onClick={canEdit ? this.handleShowEditGroup : undefined}
									style={canEdit ? { cursor: 'pointer' } : {}}
								>
									<div className="m-0 font-25">{program.groupName}</div>
									<div className="m-0 font-14 font-weight-bold">
										{program.location}
									</div>
								</div>
							</div>
						)}
						{this.isValidLink() && 
							<div className="d-flex justify-content-center">
								<h6 className="text-dark m-0 font-13">
									<a href={program.meetingLink} target="_blank" rel="noopener noreferrer">
										Meeting Link
									</a>
								</h6>
							</div>
						}
						<div className="pb-2 bg-white d-flex justify-content-center">
							{/* Equal-share `col` tiles: the row does not wrap, and with End Date it
							    carries five tiles (six for a patient), more than four 25% columns fit. */}
							<div className="d-flex session-metadata justify-content-center mt-3">
								<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
									<h6 className="detailed-nav">Last Session</h6>
									<div className="detailed-nav-value">
										{program.lastSession
											? moment(program.lastSession).format('MMM D, YYYY')
											: '-'}
									</div>
								</div>
								<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
									<h6 className="detailed-nav">Upcoming Session</h6>
									<div className="detailed-nav-value">
										{program.upcomingSession
											? moment(program.upcomingSession).format('MMM D, YYYY')
											: '-'}
									</div>
								</div>
								<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
									<h6 className="detailed-nav">End Date</h6>
									<div className="detailed-nav-value">{endDateLabel}</div>
								</div>
								<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
									<h6 className="detailed-nav">Price</h6>
									<div className="detailed-nav-value">
										${program.price} / month
									</div>
								</div>
								{type === 'patient' ? (
									<>
										<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
											<h6 className="detailed-nav">Join Date</h6>
											<div className="detailed-nav-value">
												{program.client?.startDate
													? moment(program.client.startDate).format(
															'MMM DD, YYYY',
													  )
													: '-'}
											</div>
										</div>
										<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
											<h6 className="detailed-nav">Discontinue Date</h6>
											<div className="detailed-nav-value">
												{program.client?.endDate
													? moment(program.client.endDate).format(
															'MMM DD, YYYY',
													  )
													: '-'}
											</div>
										</div>
									</>
								) : (
									<div className="my-2 col d-flex justify-content-center align-items-center flex-column">
										<h6 className="detailed-nav">Enrollees</h6>
										<div className="detailed-nav-value">
											{rowsForEnrollmentList(clients, CURRENT).length}
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		);
	};

	render() {
		const {
			type,
			updateError,
			updateSuccess,
			isMobile,
			allClients,
			auth,
			clinicians,
			groupTypes,
		} = this.props;

		const {
			activeTab,
			program,
			showAddSession,
			showUpdateEnroll,
			updateEnrollmentInfo,
			updateRequestSent,
			showAddClient,
			showSendSurvey,
			sendSurveyInfo,
			showEditGroup,
		} = this.state;

		return (
			<div className="mt-1">
				{updateRequestSent && (updateError || updateSuccess) && (
					<StatusModal
						successStatus={!updateError}
						hide={this.closeRequestSentModal}
						message={
							updateError
								? 'Something went wrong. Please try again later'
								: 'Client updated successfully'
						}
					/>
				)}
				{program && program.programId && this.getProgramHeader()}
				<div
					className={`container-fluid ${isMobile ? 'my-2 px-2' : 'mt-4 px-5'}`}
				>
					{this.getNav()}
					{type !== 'patient' && (
						<div className={'row mx-0 bg-white mb-2 p-3 justify-content-end'}>
							<CustomButton
								type="primary"
								title="+ ADD CLIENT"
								onClick={this.toggleAddClientModal}
							/>
						</div>
					)}
					{this.getTabContent(activeTab, type)}
				</div>
				{showAddSession && (
					<AddSessionModal
						hide={this.toggleShowAddSession}
						details={program}
						onSubmit={this.addNewSession}
					/>
				)}
				{showUpdateEnroll && (
					<UpdateEnrollmentModal
						isOpen={showUpdateEnroll}
						toggle={this.toggleUnenroll}
						client={updateEnrollmentInfo.client}
						groups={updateEnrollmentInfo.groups}
						onSave={this.doUpdateEnrollment}
					/>
				)}
				{showAddClient && (
					<AddClientToGroup
						program={program}
						addNewClient={this.addClient}
						patientList={allClients.filter((client) => {
							return (
								client.isActive
							);
						})}
						hide={this.toggleAddClientModal}
						mode="single"
					/>
				)}
				{showSendSurvey && (
					<SendSurveyModal
						isOpen={showSendSurvey}
						program={program}
						client={sendSurveyInfo}
						toggle={this.toggleSurvey}
						onSubmit={this.doSendSurvey}
					/>
				)}
				{/* UpdateGroup reads groupData once, at mount: wait for the program to load. */}
				{showEditGroup && program?.programId && this.canEditGroup() && (
					<UpdateGroup
						role={auth.loggedInUser.roleName}
						id={auth.loggedInUser.id}
						type={type}
						hide={this.handleShowEditGroup}
						mode="edit"
						groupTypes={groupTypes}
						clinicians={clinicians}
						groupData={program}
						updateProgram={this.handleUpdateProgram}
						isUpdating={this.props.isUpdating}
						updateConflict={this.props.updateConflict}
					/>
				)}
			</div>
		);
	}
}

GroupDetail.propTypes = {
	type: PropTypes.string.isRequired,
	fetchAttendance: PropTypes.func,
	attendance: PropTypes.array,
	doUpdateAttendance: PropTypes.func,
	fetchSessions: PropTypes.func,
	sessions: PropTypes.array,
	routeProps: PropTypes.object,
	fetchClients: PropTypes.func,
	clients: PropTypes.array,
	downloadClientFile: PropTypes.func,
	updateEnrollment: PropTypes.func,
	sendSurvey: PropTypes.func,
	clearClientUnenroll: PropTypes.func,
	program: PropTypes.object,
	dispatch: PropTypes.func,
	updateError: PropTypes.bool,
	updateSuccess: PropTypes.bool,
};

// Exported for the unit test that pins the save-confirmation wiring.
export const mapStateToProps = createStructuredSelector({
	auth: makeSelectAuth(),
	groupDetail: makeSelectGroupDetail(),
	attendance: makeSelectGetAttendance(),
	sessions: makeSelectGetSessions(),
	clients: makeSelectGetClients(),
	program: makeSelectGetProgram(),
	reloadAttendance: makeSelectReloadAttendance(),
	isMobile: makeSelectIsMobile(),
	allClients: makeSelectAllClients(),
	clinicians: makeSelectClinicians(),
	groupTypes: makeSelectGroupTypes(),
	isUpdating: makeSelectIsUpdating(),
	updateConflict: makeSelectUpdateConflict(),
	// The save confirmation is gated on this pair. The reducer sets exactly one of
	// them when the PUT settles; the component's own `updateRequestSent` state marks
	// that this page is the one waiting on it, so an outcome left in the store cannot
	// re-open the modal on a later visit.
	updateError: makeSelectUpdateRequestError(),
	updateSuccess: makeSelectUpdateRequestSuccess(),
});

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		fetchAttendance: (data, cb) => dispatch(getAttendance(data, cb)),
		doSaveAttendance: (data, res, err) =>
			dispatch(saveAttendance(data, res, err)),
		fetchSessions: (data) => dispatch(getSessions(data)),
		fetchClients: (data) => dispatch(getClients(data)),
		addNewSession: (data) => dispatch(addSession(data)),
		doDeleteSessions: (ids) => dispatch(deleteSessions(ids)),
		downloadClientFile: (docId) => dispatch(downloadFile(docId)),
		updateEnrollment: (data) => dispatch(updateEnrollment(data)),
		createToast: (data) => dispatch(generateToast(data)),
		fetchAllClients: (type) => dispatch(fetchAllClients(type)),
		addClient: (data, cb) => dispatch(addClient(data, cb)),
		sendSurvey: (data, res, err) => dispatch(sendSurvey(data, res, err)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetail);
